const css = `.vDUW1q__menuItem{scroll-margin:40px}.vDUW1q__menuItem.vDUW1q__selected:not(.vDUW1q__disabled){background-color:#c8d2d9}.vDUW1q__disabled{opacity:.5}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"selected":"vDUW1q__selected","disabled":"vDUW1q__disabled","menuItem":"vDUW1q__menuItem"};
